<template>
  <div>
    <child/>
  </div>
</template>

<script>
export default {
  name: "AuthLayout"
};
</script>



// WEBPACK FOOTER //
// src/layouts/auth.vue